import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import AdminDashboard from './AdminDashboard';
import CollaboratorDashboard from './CollaboratorDashboard';

const Dashboard: React.FC = () => {
  const { isCollaboradorProgramador, loading: permissionsLoading } = usePermissions();

  if (permissionsLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="text-gray-600">Cargando permisos...</p>
        </div>
      </div>
    );
  }

  if (isCollaboradorProgramador()) {
    return <CollaboratorDashboard />;
  }

  return <AdminDashboard />;
};

export default Dashboard;
